const getDashboardApiUrl = (parentUrl: string) => {
  if (parentUrl.includes('localhost:3000')) {
    return 'http://localhost:5000';
  }

  if (parentUrl.includes('staging-') || parentUrl.includes('myreviewlogin')) {
    return 'https://staging-dashboard.chekkit.io';
  }

  return 'https://dashboard.chekkit.io';
};

export default getDashboardApiUrl;
